import React, { useDeferredValue, useState } from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { DA_IconNames } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import { DA_Input } from "@danishagro/shared/src/components/atoms/Input/Input.component";
import { DA_Title } from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { useBackgroundColor } from "../../../../hooks/useBackgroundColor/useBackgroundColor.hook";
import { usePadding } from "../../../../hooks/usePadding/usePadding.hook";
import { V1Props } from "./DepartmentsListV1.interface";
import Department from "./components/Department/Department.component";
import S from "./DepartmentsListV1.module.scss";

const V1 = (props: V1Props) => {
    const { backgroundColorClass, hasBackgroundColor } = useBackgroundColor(props.backgroundColor);
    const { paddingClass } = usePadding(props.isCompact, hasBackgroundColor);
    const { getDictionaryString } = useTranslations();

    // Use the departments data passed via props.
    const departmentsData = props.departments || [];

    // Search state
    const [_searchQuery, setSearchQuery] = useState<string>("");
    const searchQuery = useDeferredValue(_searchQuery);

    // Filter departments using the fields (assuming department info is in dept.props)
    const filteredDepartments = departmentsData.filter((dept) => {
        const deptName = dept?.props?.departmentName?.toLowerCase() || "";
        const address = dept?.props?.address?.toLowerCase() || "";
        const zipCode = dept?.props?.zipCode?.toLowerCase() || "";
        const city = dept?.props?.city?.toLowerCase() || "";
        const combined = `${deptName}_${address}_${zipCode}_${city}`;
        return searchQuery.length > 0 ? combined.includes(searchQuery.toLowerCase()) : true;
    });

    return (
        <div className={cn(S.wrapper, paddingClass, backgroundColorClass)}>
            <DA_Container noVerticalPadding>
                <div className={S.inner}>
                    <DA_Title h2 noMargin>
                        {getDictionaryString("Department.FindUs")}
                    </DA_Title>
                    <DA_Input
                        icon={DA_IconNames.Zoom}
                        placeholder={getDictionaryString("Department.SearchDepartments")}
                        onChange={setSearchQuery}
                        className={S.search}
                    />

                    {filteredDepartments.length > 0 ? (
                        <div className={S.listWrapper}>
                            <div className={S.listCount}>
                                {filteredDepartments.length}&nbsp;
                                {getDictionaryString("Department.Departments")}
                            </div>
                            <div className={S.list}>
                                {filteredDepartments.map((department, index) => (
                                    <Department key={index} {...department} />
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div>{getDictionaryString("Department.NoItemsFound")}</div>
                    )}
                </div>
            </DA_Container>
        </div>
    );
};

export default V1;
